(function () {
  function fillUtms(root) {
    try {
      const params = new URLSearchParams(window.location.search);
      ['gclid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach((key) => {
        const val = params.get(key);
        if (!val) return;
        root.querySelectorAll('[data-mn-utm="' + key + '"]').forEach((el) => {
          el.value = val;
        });
      });
    } catch (e) {}
  }

  function initSticky(sticky) {
    if (!(sticky instanceof HTMLElement) || sticky.dataset.mnStickyInit === '1') return;
    sticky.dataset.mnStickyInit = '1';
    const buy = document.querySelector('[data-mn-buy]');
    if (!buy) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        const on = !entry.isIntersecting;
        sticky.classList.toggle('on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        const btn = sticky.querySelector('.btn');
        if (btn) btn.tabIndex = on ? 0 : -1;
      },
      { threshold: 0, rootMargin: '0px 0px -40px 0px' }
    );
    io.observe(buy);
  }

  function boot() {
    document.querySelectorAll('[data-mn-form]').forEach(fillUtms);
    document.querySelectorAll('[data-mn-sticky]').forEach(initSticky);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
